import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

export const HeaderWrapper = styled.header`
  display: flex;
  flex: 1;
  justify-content: space-between;
`;

export const AuthorDataWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const ArticleDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 150px;
  white-space: nowrap;
`;

export const AuthorDataColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 210px;
  white-space: nowrap;
`;

export const ArticleHeaderText = styled(Text14)`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
`;
